import React from "react";
import { useNavigate } from "react-router-dom";
import { PageWrapper } from "@/components/PageWrapper";
const DeletedWantAd = () => {

  const navigate = useNavigate();

  return (
    <>
      <PageWrapper>
        <div className="deletewantadpage">
          <div className="deletewantadpage__header mw-1168 my-0 mx-auto">
          </div>
          <div className="deleteWantAdWrapper">
            <h3 className="deletedWantAdHead">
              This want-listing has been removed.
            </h3>
            <p className="text-center deleteWantAdSubHead ">
              The user may have already found something!
              <br /> Sign in/up to view similar want-listings in your area.
            </p>
            <button className="btn-primary w-100" onClick={() => navigate("/home")}>
              Go back to feed
            </button>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default DeletedWantAd;
